<ng-container *ngIf="pagination.loading">
   <ng-container *ngIf="breakpoints.small">
      <div class="paginator" id="pagination_small">

         <div style="position: relative; width: {{diameter}}px; height: {{diameter}}px;">

            <mat-progress-spinner class="common-zind1" [diameter]="diameter" mode="determinate" [value]="pagination.loadingPercent"></mat-progress-spinner>

            <div class="center common-op07">
               <mat-progress-spinner [diameter]="diameter" color="primary" mode="indeterminate"></mat-progress-spinner>
            </div>

            <div id="pagination_label_small" class="percent" color="primary" class="center" style="font-size: {{diameter / 5}}px;">
               {{pagination.loadingPercent}}%
            </div>
         </div>
      </div>
      <div class="common-tacenter">
         <button id="stop_loading_small" mat-button color="primary" (click)="pagination.stop()">
            Stop Loading
         </button>
      </div>
   </ng-container>

   <ng-container *ngIf="!breakpoints.small">
      <div  class="common-pad1em" id="pagination_large">
         <div class="common-flex common-jcsb common-aicenter">
            <div class="percent common-mb05em" color="primary" id="pagination_label_large">
               Your data is loading {{pagination.loadingPercent}}%
            </div>

            <div>
               <button id="stop_loading_large" mat-button color="primary" (click)="pagination.stop()">Stop</button>
            </div>
      </div>

         <mat-progress-bar [mode]="pagination.loadingPercent ? 'determinate' : 'indeterminate'" [value]="pagination.loadingPercent"></mat-progress-bar>
      </div>
   </ng-container>
</ng-container>
